import Cookies from "js-cookie";

const COOKIES_TO_REMOVE = [
  "__hssc",
  "__hssrc",
  "__hstc",
  "_ga",
  "_ga_48FCKT8FGF",
  "_ga_CFR93M12Q7",
  "_ga_L9VNY0RY8L",
  "_ga_YPHVNNXCL7"
];

export const doCookiesToRemoveExist = () => {
  return Object.keys(Cookies.get()).some((cookie) => COOKIES_TO_REMOVE.includes(cookie));
};

export const removeAllAnalyticsCookies = () => {
  COOKIES_TO_REMOVE.forEach((cookie) => {
    Cookies.remove(cookie, { path: "/", domain: ".jukinmedia.com" });
    Cookies.remove(cookie);
  });
};
